<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-cart" label="Проверить отгрузку" styleClass="p-button-primary mr-2" (onClick)="checkShipmentPossibility($event)"
              pTooltip="Проверить возможность отгрузки со склада" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
              pTooltip="Обновить таблицу документов" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
              pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

    <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
              pTooltip="Экспортировать  список документов" tooltipPosition="top" [disabled]="!totalNotShippedOrders"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ptable4 [value]="notShippedOrdersList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [showCurrentPageReport]="true"
         [totalRecords]="totalNotShippedOrders"
         [paginator]="true"
         [loading]="loading"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
         sortMode="single"
         sortField="DOCDATE"
         sortOrder="-1"
         dataKey="DOCID"
         selectionMode="single"
         [(selection)]="notShippedSelectedDocument"
         [resizableColumns]="true"
[rowHover]="true"
         rowExpandMode="single"
         stateStorage="local"
         stateKey="dashboardOrders3-state"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestorePaidNotShipped($event)"
         (onFilter)="onFilterEvent($event)"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem !important">...</th>
      <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 8rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCDATE" style="width: 7rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 12rem !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="AUTHOR" style="width: 12rem !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PARTNERNAMESTR" style="width: auto !important">Заказчик <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCSUM" style="width: 7rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 7rem !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPSUM" style="width: 7rem !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPPED" style="width: 10rem !important">Отгружено % <p-sortIcon field="SHIPPED"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="READY2SHIP" style="width: 10rem !important">Готово % <p-sortIcon field="READY2SHIP"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 10rem !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 10rem !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
    </tr>
    <tr>
      <th >&nbsp;</th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNUMBER']" [class.hasvalue]="cf4['DOCNUMBER']" (input)="ptable4.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCDATE']" [class.hasvalue]="cf4['DOCDATE']" (input)="ptable4.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['LOCALCOMP']" [class.hasvalue]="cf4['LOCALCOMP']" (input)="ptable4.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['AUTHOR']" [class.hasvalue]="cf4['AUTHOR']" (input)="ptable4.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['PARTNERNAMESTR']" [class.hasvalue]="cf4['PARTNERNAMESTR']" (input)="ptable4.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCSUM']" [class.hasvalue]="cf4['DOCSUM']" (input)="ptable4.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['PAYDSUM']" [class.hasvalue]="cf4['PAYDSUM']" (input)="ptable4.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['SHIPSUM']" [class.hasvalue]="cf4['SHIPSUM']" (input)="ptable4.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['SHIPPED']" [class.hasvalue]="cf4['SHIPPED']" (input)="ptable4.filter($event.target.value, 'SHIPPED', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['READY2SHIP']" [class.hasvalue]="cf4['READY2SHIP']" (input)="ptable4.filter($event.target.value, 'READY2SHIP', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE1']" [class.hasvalue]="cf4['DOCNOTE1']" (input)="ptable4.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE2']" [class.hasvalue]="cf4['DOCNOTE2']" (input)="ptable4.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-nsol let-expanded="expanded">
    <tr [pSelectableRow]="nsol"
        [class.futuredocs]="nsol.fd"
        [class.grayout]="nsol.go"
        [class.underline]="nsol.ps"
        [class.strikeout]="nsol.fs"
        [class.partiallypaiddoc]="nsol.pp"
        [class.notpaiddoc]="nsol.np"
        [class.fullypaiddoc]="nsol.fp"
        [class.todaydocuments]="nsol.td"
        [class.proformadoc]="(nsol.DOCTYPEID == 12)"
        [class.inorderdoc]="(nsol.DOCTYPEID == 2)"
        [class.banktransferdoc]="(nsol.DOCTYPEID == 9)"
        [class.purchorderdoc]="(nsol.DOCTYPEID == 10)"
        [class.yellowdoc]="(nsol.DOCTYPEID == 14)"
        [class.specdoc]="(nsol.DOCTYPEID == 7)"
        [class.shiporderdoc]="(nsol.DOCTYPEID == 4)"
        [class.invoicedoc]="(nsol.DOCTYPEID == 1)">
      <td style="max-width: 5rem !important; padding:0.75rem !important;">
        <button type="button" pButton pRipple [pRowToggler]="nsol"
                class="p-button-text p-button-rounded"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td pResizableColumn ><a [routerLink]="['/edit-document', nsol.DOCTYPEID, nsol.DOCID]">{{nsol.DOCNUMBER}}</a></td>
      <td pResizableColumn >{{nsol.DOCDATE  | date:'dd.MM.yyyy'}}</td>
      <td pResizableColumn >{{nsol.LOCALCOMP}}</td>
      <td pResizableColumn >{{nsol.AUTHOR}}</td>
      <td pResizableColumn ><a [routerLink]="['/edit-client', nsol.DOCCLIENTSID]">{{nsol.PARTNERNAMESTR}}</a></td>
      <td pResizableColumn style="text-align: right">{{nsol.DOCSUM | number:'1.2-2' }}</td>
      <td pResizableColumn style="text-align: right">{{nsol.PAYDSUM | number:'1.2-2' }}</td>
      <td pResizableColumn style="text-align: right">{{nsol.SHIPSUM | number:'1.2-2' }}</td>
      <td pResizableColumn style="text-align: center"><p-progressBar [value]="nsol.SHIPPED" [style]="{ height: '1.0rem' }"></p-progressBar></td>
      <td pResizableColumn style="text-align: center"><p-progressBar [value]="nsol.READY2SHIP" [style]="{ height: '1.0rem'}"></p-progressBar></td>
      <td pResizableColumn ><input pInputText type="text" [(ngModel)]="nsol.DOCNOTE1" [style]="{'width':'100%'}" readonly alt="{{nsol.DOCNOTE1}}"></td>
      <td pResizableColumn ><input pInputText type="text" [(ngModel)]="nsol.DOCNOTE2" [style]="{'width':'100%'}" readonly alt="{{nsol.DOCNOTE2}}"></td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{totalPaidSum | number:'1.2-2' }}</td>
      <td style="text-align: right">{{totalShippedSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-nsol>
    <tr>
      <td colspan="13">
        <div class="p-p-2">
          <app-document-content-table [selectedDocumentId]="nsol.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="13">На сегодня оплаченных, но не отгруженых счетов нет</td>
    </tr>
  </ng-template>
</p-table>
